/**
 * Earlier builds registered our Workbox SW with maximum scope (entire origin), so /reservar
 * stayed "installable". Narrow scope is only applied when register() runs (from /copilot).
 * Guests who never hit /copilot after deploy would keep the legacy registration forever.
 * This unregisters our service-worker.js when its scope is still the site root.
 */
export function cleanupLegacyWeCopilotServiceWorkerScope() {
	if (!('serviceWorker' in navigator)) {
		return
	}

	navigator.serviceWorker.getRegistrations().then((registrations) => {
		for (const registration of registrations) {
			const workerUrl =
				registration.installing?.scriptURL ||
				registration.waiting?.scriptURL ||
				registration.active?.scriptURL ||
				''
			if (!workerUrl || !workerUrl.split('?')[0].endsWith('service-worker.js')) {
				continue
			}
			let scopePath
			try {
				scopePath = new URL(registration.scope).pathname.replace(/\/+$/, '') || '/'
			} catch {
				continue
			}
			const isLegacyEntireSiteScope = scopePath === '/' || scopePath === ''
			if (isLegacyEntireSiteScope) {
				registration.unregister()
			}
		}
	})
}
